import React from 'react';
import Swal from 'sweetalert2';
import AuthActionButton from './AuthActionButton';
import PrivacyTerms from './PrivacyTerms';
import { baseStyles, createInputStyle } from '../styles';
import { AuthState } from '../AuthState';
import { isEmail } from '../../ai2/helpers';
import { useAuthStep } from '../context/AuthStepContext';
import type { FormSubmitHandler } from '../types';

const allowedEmailDomains = [
  '@sa.gov.au',
  '@caremappr.com',
  '@flinders.edu.au',
  '@woolcock.org.au',
  '@mq.edu.au',
  '@health.nsw.gov.au',
  '@health.wa.gov.au',
  '@act.gov.au',
  '@curtin.edu.au',
  '@thrivefamilypractice.com.au',
  '@hampsteadhealth.com.au',
  '@thegardenmedical.com',
  '@womenshealthroad.com.au',
  '@unsw.edu.au',
  '@evehealth.com.au',
];

const EmailInputForm = () => {
  const { nextStep, setEmail, email } = useAuthStep();

  const emailChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    AuthState.email = e.target.value;
    setEmail(e.target.value);
  };

  const handleSubmit: FormSubmitHandler = (e) => {
    e.preventDefault();
    const validateResultMessage = validateEmail(email.toLowerCase());
    if (validateResultMessage) {
      Swal.fire({
        icon: 'warning',
        text: validateResultMessage,
        showConfirmButton: true,
      });
      return;
    }
    nextStep();
  };

  const validateEmail = (email: string): string | null => {
    if (!isEmail(email)) {
      return 'Please enter valid email address';
    }
    if (
      email &&
      !allowedEmailDomains.some((domain) => email.endsWith(domain))
    ) {
      return 'Please enter a valid email address';
    }
    return null;
  };

  return (
    <form style={baseStyles.clientReg} onSubmit={handleSubmit}>
      <h3>Enter your email address to login or register</h3>
      <input
        type="email"
        style={createInputStyle('default')}
        placeholder="Email"
        onChange={emailChanged}
        value={email}
        required
      />

      <AuthActionButton />
      <PrivacyTerms />
    </form>
  );
};

export default EmailInputForm;
